import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import courses from './courses'
import error from './error'
import gnaviCourses from './gnaviCourses'
import holidays from './holidays'
import reception from './reception'
import reservation from './reservation'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    courses,
    error,
    gnaviCourses,
    holidays,
    reception,
    reservation,
  },
  plugins: [
    createPersistedState({
      paths: ['reservation.edit.detail', 'reception.confirmed'],
      storage: window.sessionStorage,
    }),
  ],
})
